var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.isSubmitting}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('store-form',{attrs:{"mode":"update"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }